import coreTheme from 'gatsby-theme-core/src/layout/theme';

export default {
  blockNav: {
    linkColor: coreTheme.primaryColor,
    linkColorHover: 'white',
    linkBackgroundColorHover: 'transparent',
    buttonColor: coreTheme.primaryColor,
  },
  coverNav: {
    backgroundColor: coreTheme.primaryColor,
    linkColor: 'white',
    linkColorHover: coreTheme.primaryColor,
    linkBackgroundColorHover: 'transparent',
    linkPadding: '.25rem 0',
    buttonColor: coreTheme.primaryColor,
    borderColor: coreTheme.primaryColor,
    itemWrapperPadding: `1rem ${coreTheme.grid.columnGap}`,
  },
};
